<template>
  <div id="app" class="container">
    <div v-if="invoiceDataList.length == 0" style="text-align:center">
      <br />
      <h1><b>{{$t(showErrorText)}}</b></h1>
    </div>
    <div v-for="(itemInvoice, idx) in invoiceDataList" :key="idx">
      <invoice-template-republic
        v-if="invoiceTemplateSelected==InvoiceTemplateEnum.REPUBLIC_PALAZA"
        :item="itemInvoice"
        :projectData="projectData"
        :printInvoiceType="printInvoiceType"
        :lastPaymentDate="lastPaymentDate" />
      <invoice-template-ariyana
        v-else-if="invoiceTemplateSelected==InvoiceTemplateEnum.ARIZANA_CONDOTEL"
        :item="itemInvoice"
        :projectData="projectData"
        :printInvoiceType="printInvoiceType"
        :lastPaymentDate="lastPaymentDate" />
      <div v-else>
        <span>Not found template</span>
      </div>
      <div v-if="idx<(invoiceDataList.length-1)" class="pagebreak" />
    </div>
    <div id="mybutton">
      <lte-button
        style="float:right;"
        id="cmdPrintPdf"
        type="btn btn-primary pfeedback"
        right_icon="fa fa fa-print"
        @click="onPrintInvoice($event)"
      >
        {{ $t("common.printPdf") }}
      </lte-button>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// https://vue-multiselect.js.org/
import "bootstrap-vue/dist/bootstrap-vue.css";
import component_invoice_template_republic from "./component_invoice_template_republic";
import component_invoice_template_ariyana from "./component_invoice_template_ariyana";
import LTEButton from "@/components/LTEButton.vue";
import Loading from "vue-loading-overlay";
import siteImgConfig from '@/lib/siteImgConfig'
import InvoiceTemplateEnum from "@/enum/invoiceTemplateEnum"
import buildConfig from "../../../build/config"
import utils from "@/lib/utils";

export default {
  name: "InvoicePdfFilter",
  data() {
    return {
      invoiceDataList: [],
      period: 0,
      isLoading: false,
      showErrorText: '',
      siteImgConfig: siteImgConfig,
      projectData: null,
      printInvoiceType: 0,
      lastPaymentDate: null,
      InvoiceTemplateEnum: InvoiceTemplateEnum,
      invoiceTemplateSelected: InvoiceTemplateEnum.ARIZANA_CONDOTEL
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      "GET_INVOICE_LIST_BY_SEARCH_TEMPLATE_DATA"
    ])
  },
  methods: {
    // timeout 500ms
    timeout: function(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    onPrintInvoice: async function() {
      await this.timeout(500);

      // document.getElementById("cmdCancel").style.display = "none";
      document.getElementById("cmdPrintPdf").style.display = "none";
      window.print();
      // document.getElementById("cmdCancel").style.display = "";
      document.getElementById("cmdPrintPdf").style.display = "";
    },
    getProjectData: function() {
      this.GET_PROJECT_DETAIL({ id: utils.getProjectSession() }).then(
        function(res) {
          this.projectData = res.data
        }.bind(this)
      );
    },
    getSiteInfo: function() {
      let results = null
      let index = this.siteImgConfig.findIndex(x=>x.site_name_info_value===buildConfig.SITE_NAME_INFO)
      if (index !== -1) {
        results = this.siteImgConfig[index]
      }
      return results
    },
    updateTabTitle: function() {
      var link = document.querySelector("link[rel*='shortcut icon']");
      let siteInfo = this.getSiteInfo()
      link.href = siteInfo.urlIcon
      document.title = siteInfo.site_name_info
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_INVOICE_LIST_BY_SEARCH_TEMPLATE",
      "GET_PROJECT_DETAIL"
    ])
  },
  async mounted() {
    this.isLoading = true;
    this.updateTabTitle()

    let routeQuery = this.$route.query
    this.printInvoiceType = routeQuery && routeQuery.printInvoiceType
    this.lastPaymentDate = routeQuery && routeQuery.lastPaymentDate
    this.invoiceTemplateSelected = routeQuery && routeQuery.templateId
    let searchDataQuery = routeQuery && routeQuery.searchData
    searchDataQuery=searchDataQuery !== undefined ? JSON.parse(searchDataQuery) : {}
    await this.getProjectData()
    let list_invoice_ids = [];
    if (routeQuery.list_invoice_ids != null) {
      if (typeof routeQuery.list_invoice_ids === "string") {
        list_invoice_ids = [routeQuery.list_invoice_ids];
      } else {
        list_invoice_ids = routeQuery.list_invoice_ids;
      }
    }
    let exclude_invoice_ids = [];
    if (routeQuery.exclude_invoice_ids != null) {
      if (typeof routeQuery.exclude_invoice_ids === "string") {
        exclude_invoice_ids = [routeQuery.exclude_invoice_ids];
      } else {
        exclude_invoice_ids = routeQuery.exclude_invoice_ids;
      }
    }
    let invoiceType = routeQuery.invoiceType !== undefined ? routeQuery.invoiceType : null
    let accountingPeriod = (routeQuery.picked == 2) ? searchDataQuery && searchDataQuery.accountingPeriod : routeQuery.accountingPeriod
    const data = {
      list_invoice_ids: list_invoice_ids,
      exclude_invoice_ids: exclude_invoice_ids,
      picked: parseInt(routeQuery.picked),
      // period: routeQuery.period,
      is_price_contain: parseInt(routeQuery.is_price_contain),
      invoiceType: invoiceType,
      accountingPeriod: accountingPeriod,
      // update filter invoice
      invoiceNumber: searchDataQuery && searchDataQuery.invoiceNumber,
      apartmentCode: searchDataQuery && searchDataQuery.apartmentCode,
      ownerApartment: searchDataQuery && searchDataQuery.ownerApartment,
      apartmentGroupIdFilter: searchDataQuery && searchDataQuery.apartmentGroupIdFilter,
      dateCreatedInvoiceFrom: searchDataQuery && searchDataQuery.dateCreatedInvoiceFrom,
      dateCreatedInvoiceTo: searchDataQuery && searchDataQuery.dateCreatedInvoiceTo,
      invoiceStatus: searchDataQuery && searchDataQuery.invoiceStatus
    };
    await this.GET_INVOICE_LIST_BY_SEARCH_TEMPLATE(data).then(
      function(res) {
        this.invoiceDataList = res;
        this.isLoading = false;
        if (this.invoiceDataList.length > 0) {
          // this.onPrintInvoice()
        } else {
          this.showErrorText = 'common.errorNotFoundInformationPrint'
        }
      }.bind(this)
    );
  },
  components: {
    "invoice-template-republic": component_invoice_template_republic,
    "invoice-template-ariyana": component_invoice_template_ariyana,
    "lte-button": LTEButton,
    loading: Loading
  }
};
</script>

<style scoped>
.btn-label {
  position: relative;
  left: -12px;
  display: inline-block;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px 0 0 3px;
}

.btn-labeled {
  padding-top: 0;
  padding-bottom: 0;
}

.btn {
  margin-bottom: 10px;
}

.table_total_fee {
  border: 2px solid #000000;
}

.table_total_fee thead tr,
.table_total_fee thead tr th,
.table_total_fee td,
.table_total_fee th {
  border: 2px solid #000000;
}

.container {
  font-family: Times New Roman, Times, serif !important;
}

body {
  font-size: 12px !important;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}

/* Break page */
@media print {
  #mybutton {
    display: none;
  }
  .pagebreak {
    clear: both;
    page-break-after: always;
  }
}
/* remove title when print */
@page {
  size: auto;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Invoice/InvoicePdfFilter.vue